import React from "react";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  DatePicker,
  Radio,
} from "antd";
import "./style.css";
import success_img from "../../assets/Holding a Gold Hoop.webp";
import hoodie from "../../assets/hoodie.webp";
import shirt from "../../assets/shirt.webp";
import men from "../../assets/men.webp";
import women from "../../assets/women.webp";
import unamed from "../../assets/unnamed.jpg";
import api from "../../api";
import { FaFacebookF } from "react-icons/fa6";
import { BiLogoLinkedin } from "react-icons/bi";
import { FaInstagram } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../navbar";
import useWindowDimensions from "../../utils/getWindowDimenssions";

const LandingPage = () => {
  const { height, width } = useWindowDimensions();
  const [form] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const onFinish = async (values) => {
    console.log("Success:", values);
    const res = await api.post(`/auth/contactus`, values);
    if (res.status == 201) {
      form.resetFields();
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <div className="landing_page">
        <Navbar user={user} />
        <div className="landing_main">
          <Row
            justify={width > 500 ? "space-around" : "center"}
            className="section_1"
            align="middle"
          >
            <Col md={7}>
              {" "}
              <div className="sec_1_left">
                <div
                  style={{
                    fontSize: "50px",
                    fontWeight: "600",
                    fontFamily: "'Times New Roman', Times, serif",
                  }}
                >
                  SUCCESS CLUB.
                </div>
                <p
                  style={{
                    fontWeight: "700",
                    fontSize: "28px",
                    lineHeight: "1.5em",
                    wordSpacing: "1rem",
                    color: "rgba(177,121,15,1)",
                  }}
                >
                  FILL OUT THE FORM BELOW TO GAIN INFORMATION AND A SCREENING
                  INTERVIEW.
                </p>
              </div>
            </Col>
            <Col md={10}>
              {" "}
              <div className="sec_1_right">
                <div
                  style={{
                    fontSize: "23px",
                    fontFamily: "'Times New Roman', Times, serif",
                    fontWeight: "bold",
                    marginTop: "2rem",
                  }}
                >
                  STAY TUNED FOR OUR NEW SOFTWARE
                </div>
                <p style={{ fontSize: "17px", lineHeight: "1.8rem" }}>
                  Welcome to Success Club! We pride ourselves on being an
                  educated business group, where we prioritize achieving
                  business success and working together strategically. Our
                  exclusive co-working space, available select evenings,
                  provides a collaborative and inspiring atmosphere. Our
                  experienced team members and business leaders are here to help
                  you thrive, not just survive.
                </p>
                <img src={success_img} />
              </div>
            </Col>
          </Row>
          <div className="sec_2">
            <div
              style={{
                fontWeight: "bold",
                fontSize: "4rem",
                fontFamily: "'Times New Roman', Times, serif",
              }}
            >
              Explore the Collection
            </div>
            <div style={{ fontSize: "1.2rem", marginTop: "2rem" }}>
              Here you can get your own Success Club™ t-shirts!
            </div>
            <div style={{ fontSize: "1.2rem", marginTop: "1rem" }}>
              More merch coming soon...
            </div>
            <div className="cards">
              <Row justify={"center"} gutter={[16, 16]}>
                <Col md={6}>
                  <div
                    className="item"
                    onClick={() => {
                      window.open(
                        "https://www.rae-enterprise.com/product-page/success-club-hoodie",
                        "_blank"
                      );
                    }}
                  >
                    <img src={hoodie} width={280} height={280} />
                    <div className="title">Success Club™ Hoodie</div>
                    <div className="price">$66.50</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="item"
                    onClick={() => {
                      window.open(
                        "https://www.rae-enterprise.com/product-page/success-club-crew",
                        "_blank"
                      );
                    }}
                  >
                    <img src={shirt} width={280} height={280} />
                    <div className="title">Success Club™ Crew</div>
                    <div className="price">$52.00</div>
                  </div>
                </Col>
                <Col md={6}>
                  {" "}
                  <div
                    className="item"
                    onClick={() => {
                      window.open(
                        "https://www.rae-enterprise.com/product-page/women-s-success-club-crop-t",
                        "_blank"
                      );
                    }}
                  >
                    <img src={women} width={280} height={280} />
                    <div className="title">Women’s Success Club™ Crop T</div>
                    <div className="price">$35.50</div>
                  </div>
                </Col>
                <Col md={6}>
                  {" "}
                  <div
                    className="item"
                    onClick={() => {
                      window.open(
                        "https://www.rae-enterprise.com/product-page/men-success-club-t",
                        "_blank"
                      );
                    }}
                  >
                    <img src={men} width={280} height={280} />
                    <div className="title">Men's Success Club™ T</div>
                    <div className="price">$35.99</div>
                  </div>
                </Col>
              </Row>
            </div>
            <div>
              <button
                className="item_button"
                onClick={() => {
                  window.open(
                    "https://www.rae-enterprise.com/category/all-products",
                    "_blank"
                  );
                }}
              >
                Shop Now
              </button>
            </div>
          </div>
          <Row justify={"space-between"}>
            {" "}
            <div className="sec_3_left">
              More on...{" "}
              <span
                style={{
                  fontSize: "50px",
                  fontFamily: "'Times New Roman', Times, serif",
                  fontStyle: "italic",
                }}
              >
                SUCCESS CLUB
              </span>{" "}
              Business{" "}
            </div>{" "}
            <div className="sec_3_right">
              <div className="para">
                We are an exclusive community dedicated to cultivating success
                through strategic collaboration and collective empowerment. At
                Success Club™, we understand that the journey to business
                excellence requires not just individual effort, but the power of
                a supportive community.
              </div>
              <div className="para">
                In the spirit of ushering in the new year with unparalleled
                success, we are thrilled to announce the launch of our official
                Accountability Cohort in 2024. This innovative program is
                designed to provide our esteemed members with a structured and
                dynamic platform to elevate their businesses to new heights.
              </div>
              <div className="para">
                As a member of the Accountability Cohort, you will join a select
                group of like-minded individuals who are committed to achieving
                greatness in their respective ventures. Our focus is not just on
                individual triumphs but on the collective success that emerges
                when brilliant minds come together.
              </div>
              <div className="para">
                What sets Success Club™ apart is our commitment to education and
                luxury. Our curated sessions and workshops are led by industry
                experts who bring a wealth of knowledge and experience to the
                table. Prepare to be inspired, motivated, and equipped with the
                tools you need to navigate the intricate landscape of business
                with finesse.
              </div>
              <div className="para">
                But that's not all—Success Club™ understands the importance of a
                conducive work environment. That's why, on select evenings, we
                provide an exclusive collective co-working space where members
                can collaborate, innovate, and propel their projects forward in
                a luxurious setting.
              </div>
              <div className="para">
                The Accountability Cohort is more than just a program; it's a
                transformative experience. Through structured goal-setting,
                regular check-ins, and a supportive network of peers, you will
                embark on a journey of growth and accomplishment. This is your
                opportunity to set the tone for a successful year and make
                meaningful strides in your business endeavors.
              </div>
              <div className="para">
                Join us at Success Club™ and be part of a community that thrives
                on excellence, collaboration, and the pursuit of extraordinary
                success. Welcome to a new era of business triumph—welcome to the
                Success Club™ Accountability Cohort 2024. Your success story
                begins here
              </div>
            </div>
          </Row>
          <div className="sec_4">
            <Row justify={"space-around"}>
              <Col md={9}>
                <div className="image" style={{ border: "1px solid black" }}>
                  <h1
                    style={{
                      fontFamily: "'Times New Roman', Times, serif",
                      fontSize: "3.2rem",
                      margin: "0px 3rem",
                    }}
                  >
                    Host Status Admittance
                  </h1>
                  <hr
                    style={{
                      width: "3rem",
                      backgroundColor: "white",
                      marginLeft: "3rem",
                    }}
                  />
                  <div
                    style={{
                      fontSize: "20px",
                      margin: "0px 40px",
                      width: "250px",
                    }}
                  >
                    Complete this form to gain a screening interview.
                  </div>
                </div>
              </Col>
              <Col md={10}>
                <div className="form">
                  {" "}
                  <Form
                    name="basic"
                    labelCol={{
                      span: 18,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                  >
                    <Row justify={"space-between"} gutter={[12, 12]}>
                      <Col xs={24} md={12}>
                        <label>Business Name</label>
                        <Form.Item
                          name="business_name"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                          ]}
                        >
                          <Input className="name" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <label>UBI</label>
                        <Form.Item
                          className="email"
                          name="ubl"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                          ]}
                        >
                          <Input className="email__" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify={"space-between"}>
                      <Col xs={24} md={11}>
                        <label>Business Insurance</label>
                        <Form.Item
                          name="business_insurance"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                          ]}
                        >
                          <Radio.Group>
                            <Radio value="Yes">Yes</Radio>
                            <Radio value="No">No</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={11}>
                        <label>Contact Name</label>
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                          ]}
                        >
                          <Input className="phone" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify={"space-between"}>
                      <Col xs={24} md={11}>
                        <label>Contact Email</label>
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                            {
                              type: "email",
                              message: "Invalid Email",
                            },
                          ]}
                        >
                          <Input className="phone" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={11}>
                        <label>Contact Number</label>
                        <Form.Item
                          name="number"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                          ]}
                        >
                          <Input className="phone" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <div style={{ textAlign: "center" }}>
                      <button htmlType="submit" className="submit">
                        Submit
                      </button>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
          <div
            className="footer"
            style={{ backgroundColor: "rgb(177, 121, 15)", padding: "2rem" }}
          >
            <div className="about" style={{ color: "white" }}>
              <Row justify={"center"}>
                <Col md={6}>
                  <div style={{ textAlign: "center" }}>710 Pacific Ave </div>
                  <div style={{ textAlign: "center" }}>Tacoma WA 98402</div>
                </Col>

                <Col md={6}>
                  {" "}
                  <div
                    style={{
                      wordSpacing: "5px",
                      fontSize: "1.5rem",
                      fontFamily: "lulo-clean-w01-one-bold, sans-serif",
                      textAlign: "center",
                    }}
                  >
                    Success Club Corporate
                  </div>
                  <div style={{ textAlign: "center" }}>
                    Strategic Success Network
                  </div>
                </Col>

                <Col md={6}>
                  <div style={{ textAlign: "center" }}>
                    info@successclub.com
                  </div>
                </Col>
              </Row>
            </div>

            <div
              className="social"
              style={{
                color: "white",
                textAlign: "center",
                fontSize: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "2rem",
                gap: "1rem",
              }}
            >
              <FaFacebookF
                cursor="pointer"
                onClick={() => {
                  window.open(
                    "https://www.facebook.com/profile.php?id=61562476438009&mibextid=LQQJ4d",
                    "_blank"
                  );
                }}
              />
              <BiLogoLinkedin
                cursor="pointer"
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/success-club%E2%84%A2/",
                    "_blank"
                  );
                }}
              />
              <FaInstagram
                cursor="pointer"
                onClick={() => {
                  window.open(
                    "https://www.instagram.com/rae.enterprise.llc/",
                    "_blank"
                  );
                }}
              />
            </div>
            <div
              className="copyright"
              style={{
                color: "white",
                textAlign: "center",
                fontSize: "20px",
                marginTop: "1rem",
              }}
            >
              © Copyright 2023 in conjunction with Rae Enterprise LLC{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
